import toastStore from '@/stores/toast'
import axios from 'axios'
import type { CreateAxiosDefaults, AxiosInterceptorOptions } from 'axios'

import type { Response } from '@/models/api-generated'
import i18n from '@/i18n'

const config: CreateAxiosDefaults = {}
const http = axios.create(config)
export default http

// @ts-ignore
const options: AxiosInterceptorOptions = {}
function isCanceled(err: any) {
	if (err?.code === 'ERR_CANCELED' || err?.code === 'ECONNABORTED') {
		return true
	}
	return false
}
export function initHttp() {
	const toaster = toastStore()

	// Implement global error handling
	http.interceptors.response.use(
		function (response) {
			return response
		},
		function (error) {
			// Permission denied
			if (error.response?.status === 401) {
				toaster.showError(i18n.global.t('misc.notPermitted'))
				return Promise.reject(error)
			}
			// ignore client side aborts
			if (isCanceled(error)) {
				return Promise.resolve({
					data: {},
					status: 499,
					statusText: error?.name,
				})
			}
			// Browser problems
			if (!error.response) {
				if (i18n.global.te(error.response)) toaster.showError(i18n.global.t(error.response))
				else toaster.showError(error.message)
				return Promise.reject(error)
			}

			const err = error.response.data as Response<any>
			// Well formed API errors
			if (err.errors) {
				// i18n doesn't accept . or : characters in its key
				const cleanKey = err.errors.detail.replace(/[:.]/g, '').replace(/\s+/g, ' ').trim()
				const key = `apiErrors.${cleanKey}`
				if (i18n.global.te(key)) toaster.showError(i18n.global.t(key))
				else toaster.showError(err.errors.detail)
			}
			// Internal server error
			else if (error.response.data.message) {
				toaster.showError(error.response.data.message)
			}
			// Fall-back to browser problems
			else {
				toaster.showError(error.message)
			}
			return Promise.reject(error)
		},
	)
}
